/**
 * @file Base class for components with access to the ShopHub singleton
 */
import {v4 as uuidv4} from 'uuid';

import WebComponent from './WebComponent';
import {ShopHub, ShopHubPayload, ShopHubTopic} from './utils';

export default abstract class ConnectedWebComponent extends WebComponent {
  private shopHub = ShopHub.getInstance();
  private publisherId: string = uuidv4();

  protected subscribeToHub(
    topic: ShopHubTopic,
    callback: (payload: ShopHubPayload) => void,
  ): void {
    this.shopHub.subscribe(topic, this.publisherId, callback);
  }

  protected unsubscribeAllFromHub(): void {
    this.shopHub.unsubscribeAll(this.publisherId);
  }

  protected unsubscribeFromHub(topic: ShopHubTopic): void {
    this.shopHub.unsubscribe(topic, this.publisherId);
  }

  protected publishToHub(
    topic: ShopHubTopic,
    payload: ShopHubPayload | undefined = {},
  ): void {
    this.shopHub.publish(topic, this.publisherId, payload);
  }
}
